import { render, staticRenderFns } from "./TakeImage.vue?vue&type=template&id=106a6c34&"
import script from "./TakeImage.vue?vue&type=script&lang=js&"
export * from "./TakeImage.vue?vue&type=script&lang=js&"
import style0 from "./TakeImage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports